import type React from 'react';

import type Cropper from 'cropperjs';

import type { MediaCropArea } from '#src/app/shared/hooks/imageUpload';
import type { UploaderControls } from '#src/app/shared/hooks/uppyUploader';

import { ImageCropperSunrise } from '../imageCropper';
import { ImageUploaderSunriseV2 as ImageUploaderSunrise } from '../imageUploader';

type Props = {
	crop?: MediaCropArea | undefined;
	disabled?: boolean;
	image?: string | null;
	onImageChange: (image: string | undefined) => void;
	onImageCrop: (imageCrop: MediaCropArea | undefined) => void;
	onButtonClick?: () => void;
	onCancelClick?: () => void;
	uploader: UploaderControls;
	onInitialized?: (instance: Cropper) => void;
};

export const ImageCropperUploader: React.FC<Props> = ({
	crop,
	disabled = false,
	image,
	onButtonClick,
	onImageCrop,
	onImageChange,
	onCancelClick,
	uploader,
	onInitialized,
}) => {
	return (
		<>
			{image && (
				<ImageCropperSunrise
					crop={crop}
					disabled={disabled}
					image={image}
					onCancelClick={onCancelClick}
					onImageChange={onImageChange}
					onImageCrop={onImageCrop}
					uploader={uploader}
					onInitialized={onInitialized}
				/>
			)}
			{!image && <ImageUploaderSunrise disabled={disabled} onButtonClick={onButtonClick} uppy={uploader.uppy} />}
		</>
	);
};
